import { combineReducers } from '@reduxjs/toolkit';
import { channelSettingsTabSlice } from './channelSettingsTab.slice';
import { companyTabSlice } from './companyTab.slice';

export const companyTabReducer = combineReducers({
  companyDataTab: companyTabSlice.reducer,
  channelSettingsTab: channelSettingsTabSlice.reducer
});
